var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3kwsg5zhqa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.533333 0 0 0 0 0.533333 0 0 0 0 0.501961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#3kwsg5zhqa)",
    transform: "translate(-138.000000, -235.000000) translate(22.000000, 210.000000) translate(-1.000000, 0.000000) translate(117.335293, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#14233C",
    strokeWidth: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .481L0 3.37 2.909 3.37M10.667 8.186L10.667 5.297 7.758 5.297",
    transform: "translate(0.000000, 1.000000) translate(2.666667, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45 2.889C8.95 1.486 7.76.435 6.299.107c-1.461-.328-2.99.11-4.05 1.163L0 3.37m10.667 1.927l-2.25 2.1c-1.06 1.052-2.588 1.491-4.05 1.163-1.46-.329-2.65-1.379-3.15-2.782",
    transform: "translate(0.000000, 1.000000) translate(2.666667, 4.000000)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic-refresh.ebe87a021db3b0aa3d13022a370a7ccd.svg";
export { ForwardRef as ReactComponent };